var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVarianceGood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77 40.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#18c60b;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76,7.25a6.25,6.25,0,0,1-12.5,0,6.25,6.25,0,0,0-12.5,0,6.25,6.25,0,0,1-12.5,0,6.25,6.25,0,0,0-12.5,0,6.25,6.25,0,0,1-12.5,0A6.25,6.25,0,0,0,1,7.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76,20a6.25,6.25,0,0,1-12.5,0A6.25,6.25,0,1,0,51,20a6.25,6.25,0,0,1-12.5,0A6.25,6.25,0,0,0,26,20a6.25,6.25,0,0,1-12.5,0A6.25,6.25,0,0,0,1,20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76,32.83a6.25,6.25,0,0,1-12.5,0,6.25,6.25,0,0,0-12.5,0,6.25,6.25,0,0,1-12.5,0,6.25,6.25,0,0,0-12.5,0,6.25,6.25,0,0,1-12.5,0,6.25,6.25,0,0,0-12.5,0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarianceGood);
export default __webpack_public_path__ + "static/media/variance_good.2c7df48b17bfa880edcb54c7d6bd745e.svg";
export { ForwardRef as ReactComponent };